export const BrandsData = [
    // {
    //     category: ["spirits"],
    //     img: "Abasolo.svg",
    // },
    {
        category: ["w&j"],
        img: "AcquaPanna.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "AnchoReyes.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Angostura.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "Aromo.svg",
    // },
    // {
    //     category: ["beers"],
    //     img: "Asahi.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "Avgvstvs.svg",
    // },
    {
        category: ["wines"],
        img: "Belaire.svg",
    },
    {
        category: ["spirits"],
        img: "Bols.svg",
    },
    {
        category: ["spirits"],
        img: "Bulldog.svg",
    },
    // {
    //     category: ["wines"],
    //     img: "Caleuche.svg",
    // },
    // {
    //     category: ["beers"],
    //     img: "Cerveceria14.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "ChateauLarteau.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "ChateauSenilhac.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Chinola.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Cihuatan.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "CruzDeAlba.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "CuttySark.svg",
    // },
    {
        category: ["beers"],
        img: "Delirium.svg",
    },
    // {
    //     category: ["wines"],
    //     img: "Dogma.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "DomaineDeCanton.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Drambuie.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "ElRecuerdo.svg",
    // },
    {
        category: ["spirits"],
        img: "Espolon.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "EvanWilliams.svg",
    // },
    {
        category: ["spirits"],
        img: "Glenfiddich.svg",
    },
    {
        category: ["spirits"],
        img: "GrandMarnier.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "GranMalo.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Grants.svg",
    // },
    {
        category: ["beers"],
        img: "Grolsch.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "Hpnotiq.svg",
    // },
    {
        category: ["spirits"],
        img: "Jagermeister.svg",
    },
    {
        category: ["spirits"],
        img: "Licor43.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "Lolea.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Luxardo.svg",
    // },
    // {
    //     category: ["beers"],
    //     img: "Mahou.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "MarDeFrades.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "MartinMillers.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "Minuty.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "MonkeyShoulder.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Nixta.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Nuvo.svg",
    // },
    {
        category: ["w&j", "groceries"],
        img: "Ocean.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "OjoDeTigre.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Pama.svg",
    // },
    {
        category: ["beers"],
        img: "Peroni.svg",
    },
    {
        category: ["w&j"],
        img: "Perrier.svg",
    },
    {
        category: ["spirits"],
        img: "PuertodeIndias.svg",
    },
    // {
    //     category: ["wines"],
    //     img: "RamonBilbao.svg",
    // },
    {
        category: ["w&j"],
        img: "SPellegrino.svg",
    },
    // {
    //     category: ["wines"],
    //     img: "SantaMargherita.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "StambeccoItaly.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "Suze.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "TequilaOcho.svg",
    // },
    // {
    //     category: ["wines"],
    //     img: "Terreliade.svg",
    // },
    // {
    //     category: ["spirits"],
    //     img: "TheGlenrothes.svg",
    // },
    {
        category: ["spirits"],
        img: "Titos.svg",
    },
    {
        category: ["wines"],
        img: "Torresella.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "TullamoreDew.svg",
    // },
    // {
    //     category: ["groceries"],
    //     img: "Yucateco.svg",
    // },
];
